// Replaces all occurences of <span class="coms-sp-title">O<sub>2</sub></span> with a simple "o2" which
// is then displayed as the correct O2 logo in dsONEs "Air" font as a ligature.
export const replaceO2SpanWithAirFontLigature = (node: ShadowRoot | HTMLElement) => {
  node.querySelectorAll<HTMLSpanElement>('span.coms-sp-title').forEach((span$) => {
    if (/o2/.test(span$.innerText.toLowerCase())) {
      span$.innerHTML = 'o2'; // eslint-disable-line no-param-reassign
    }
  });
};
